import BrandsIndexPage from '../../components/pages/brands/BrandsIndexPage.vue'

export default {
  components: { BrandsIndexPage }
}
